
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import ModalStylePageLayout from '@/components/organisms/layout/ModalStylePageLayout.vue'
import ColorCurriculumUnitBox from '@/components/organisms/ColorCurriculumUnitBox.vue'
import { LearningStatusCurriculumUnit, CurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 増進堂単元から日能研単元を選択
 */
@Component({
  components: {
    ButtonSubmit,
    ModalStylePageLayout,
    ColorCurriculumUnitBox,
  },
})
export default class ZnSelectCurriculumUnit extends Vue {
  /** 増進堂単元情報 */
  @Prop()
  private znCurriculumUnit!: CurriculumUnit

  /** 日能研単元情報のリスト */
  @Prop()
  private curriculumUnitList!: LearningStatusCurriculumUnit[]

  /** 日能研単元クリック時のイベント */
  @Prop()
  private eventClickCurriculumUnit!: (id: number) => void

  /** 戻るボタン押下時のイベント */
  @Prop()
  private eventClickBackButton!: () => void
}
